import { useState } from "react"

import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';

import Logo from "../assets/logo.png"
import "../App.css"


function Navbar({ theme, setURL, setOpenModal }) {
    const [isNavExpanded, setIsNavExpanded] = useState(false)

    return (
        <nav className="navbar">
            <a className="logo-link" target="_blank" rel="noreferrer" href="https://www.descope.com/">
                <img className="logo" src={Logo} alt="" />
            </a>
            {isNavExpanded ? 
                <CloseIcon className="hamburger" onClick={() => {setIsNavExpanded(!isNavExpanded)}}/>
                :
                <MenuIcon className="hamburger" onClick={() => {setIsNavExpanded(!isNavExpanded)}}/>
            }
            <div className={isNavExpanded ? "navbar-menu expanded" : "navbar-menu"}>
                <ul>
                    <li className="navbar-btn-li">
                        <button className="navbar-btn question-icon" onClick={() => setOpenModal({open: true, modalType: "Questions"})}><QuestionMarkIcon /></button>
                    </li>
                </ul>
            </div>
        </nav>
    )
}

export default Navbar














